module.exports = __webpack_public_path__ + "media/images/logo/LOGO LPS-6bb4801032082585f3665035f5d14fe4.png";